import { render, staticRenderFns } from "./NowhowUInt32Box.vue?vue&type=template&id=c210f9f6"
import script from "./NowhowUInt32Box.vue?vue&type=script&lang=ts"
export * from "./NowhowUInt32Box.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports